import { InlineChildren, Media, Spacing } from '@doordash/design-language'
import styled from 'styled-components'

export const Wrapper = styled.div`
  max-width: 500px;
  margin: 0 auto;
  padding: ${Spacing.Medium}px;
  padding-top: 0;

  .react-swipe-container {
    height: 90%;

    > div {
      height: 100%;
    }
  }
`

export const Slide = styled.div`
  height: 100%;
`

export const SlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  padding: ${Spacing.Small}px;
`

export const SlideButtonWrapper = styled.div`
  ${Media.Mobile`
    display: none;
  `}
`

export const Bottom = styled.div`
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${Spacing.Large}px;
`

export const ContentContainer = styled(InlineChildren)`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const ImageContainer = styled.div`
  margin-left: 0 !important;
`